export default __webpack_public_path__ + "static/media/dieppe12.b6c61dd5.jpg";